let mobileElements = {
  mobileMenu: document.querySelector('.mobile-menu'),
  mobileMenuTrigger: document.querySelector('.header__mobileMenuTrigger'),
  body: document.querySelector('body'),
  header: document.querySelector('.header'),
  items: document.querySelectorAll('.menu-item')
}

let { mobileMenuTrigger, mobileMenu, body, header, items } = mobileElements;

const animateItems = () => {

  let interval = 50;

  items.forEach((i, index) => {
    i.addEventListener('click' , () => {
      toggleChildren(i);
    });
    if (!i.classList.contains('reveal')) {
      setTimeout(function () {
        i.classList.toggle('reveal');
      }, index * interval);
    } else {
      i.classList.toggle('reveal');
    }
  });

}

function toggleMenu() {

  mobileMenu.classList.toggle('mobile-menu--active');
  mobileMenuTrigger.classList.toggle('header__mobileMenuTrigger--opened');
  body.classList.toggle('stopScroll');
  header.classList.toggle('header--menuOpen');

  animateItems();
}

function toggleChildren(item) {
  
  jQuery(item).toggleClass('menu-item--active');
  jQuery(item).find('.sub-menu').slideToggle();
}

function MobileMenu () {

  mobileMenuTrigger.addEventListener('click', () => toggleMenu());

}

export default MobileMenu;